<template>
    <div class="placement">
      <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
        <svg class="icon" aria-hidden="true" style="color: #fff;">
        <use xlink:href="#icon-a-PaidPlacement"></use>
       
      </svg>
    </breadcrumbs>
    <div class="content-wrapper">
      <div class="table-head">
        <a-space class="filters">
          <a-input-search v-model:value="params.keyword" placeholder="Search..." allow-clear @search="onSearch"
            @enter="onSearch">
          </a-input-search>
         
          <div class="statusFilter" ref="statusFilter" >
            <span style="margin-right: 8px;">Status:</span>
            <artmisads-select style="width: 200px;" v-model:value="params.status" :getPopupContainer="() => $refs.statusFilter"  @change="onStatusChange" trigger="click">
              <a-select-option value="">All</a-select-option>
              <a-select-option value="draft">Draft</a-select-option>
              <a-select-option value="reviewing">Pending Review</a-select-option>
              <a-select-option value="approved">Approved</a-select-option>
              <a-select-option value="rejected">Rejected</a-select-option>
              <a-select-option value="insufficient_stock">Out of stock</a-select-option>
              <a-select-option value="offline">Removed</a-select-option>
            </artmisads-select>
          </div>
        </a-space>
        <artmisads-select-button type="primary"  
        @click="addNewPlacement">Add New Placement</artmisads-select-button>
      </div>
      <div class="table">
        <artmisads-table 
      :loading="loading" 
      :columns="columns" 
      :data-source="dataList" 
      :scroll="{ x:1500,y: tableScrollHeight  }"
      :pagination="{
        total: tableTotal,
        current: params.page,
        pageSize: params.size,
        showTotal: (total, range) => `Total ${total} items`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100', '200']
      }" 
      :change="onChangePage">
      <template #bodyCell="{ column, text, index, record }">
        <template v-if="column.name === 'price'">
          {{record?.price? CURRENCY_DATA_MAPPER[record?.currency]:'' }} {{ record?.price?.toFixed(2)||'--' }}
        </template>
        <template v-if="column.name === 'duration'">
          {{ record?.durationDays? record?.durationDays + ' Days' :'--' }}
        </template>
        <template v-if="column.name === 'availableFrom'">
          {{record?.availableFrom? setTime(record?.availableFrom) :'--' }}
        </template>
        <template v-if="column.name === 'autoAcceptRequests'">
          {{ record?.autoAcceptRequests ? 'Yes' : 'No' }}
        </template>
        <template v-if="column.name === 'status'">
          <div v-if="record?.status === 'completed'">
            <PlacementStatus :type="statusInfo[record?.status]?.type || '--'"
            :text="'Published'" />
          </div>
          <div v-else>
            <PlacementStatus :type="statusInfo[record?.status]?.type || '--'"
            :text="statusInfo[record?.status]?.text || '--'" />
          </div>
          
        </template>
      
          <template v-if="column.name === 'action'">
            <div class="action-container">
          <artmisads-select-button size="small" 
           @click="editPlacement(record?.status,record?.id)"
           :style="record?.status=='offline'?'color:red':''"
            >{{returnText(record?.status)}}</artmisads-select-button>
          <artmisads-select-button size="small"
       
           @click="offlinePlacement(record?.id)"
            style="margin-left: 8px;"
             v-if="record?.status=='approved'">Remove</artmisads-select-button>
             </div>
        </template>
      </template>
    </artmisads-table>
      </div>
      
    </div>
    <model
      ref="modelRef"
      @refresh="handleRefresh"
    />
    </div>
</template>

<script setup lang="jsx">
import { ref,onMounted } from 'vue'
import breadcrumbs from '@/components/breadcrumbs.vue'
import model from './components/model.vue'
import { Modal, message } from 'ant-design-vue'
import { publisherPlacementApi } from '~/server/index'
import { CURRENCY_DATA_MAPPER } from '~/contants/common'
import { useTableScrollHeight } from '@/utils/useTableScrollHeight'

import { statusInfo } from '@/contants/common'
import PlacementStatus from '@/components/placementStatus.vue'
import { setTime } from '~/utils'

const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table',
  bottomSpace: 100,
  minHeight: 300,
  maxHeight:800,
  defaultHeight: 600
});
const modelRef = ref(null)
const breadcrumbsData = {
  title: "Placement Info",
  des: "Manage your placements information",
  color: '#80C026',
  hasTitleIcon: true,
  links: [
    {
      name: "Home",
      path: "/publisher/dashboard",
    },
    {
      name: "Paid Placements",
      path: "/publisher/settings/paidPlacement/placement",
    },
    {
      name: "Placement Info",
      path: "/publisher/settings/paidPlacement/placement",
    },
  ],
}
const dataList = ref([])
const tableTotal = ref(0)
const loading = ref(false)
const params = ref({
  page: 1,
  size: 10,
  keyword: '',
  status: '',
  
})
const columns = ref([
  {
    title: 'Name',
    dataIndex: 'name',
    customRender: ({ text, record }) => {
      return <div>{record.name||'--'}</div>
    },
  },
 
  {
    title:'Specs',
    dataIndex: 'specifications',
    customRender: ({ text, record }) => {
      return <div>{record.specifications||'--'}</div>
    },
  },
  {
    title:'Price',
    name: 'price',
    dataIndex: 'price',
    width:160
  },
  {
    title:'Inventory',
    dataIndex: 'availableInventory',
    customRender: ({ text, record }) => {
      return <div>{record.availableInventory||'--'}</div>
    },
  },
  {
    title:'Duration',
    name: 'duration',
  },
  {
    title:'AvailableFrom',
    dataIndex: 'availableFrom',
    name: 'availableFrom',
  },
  {
    title:"Status",
    dataIndex: 'status',
    name: 'status',
    width:200
  },
  {
    title:'Auto-confirm',
    dataIndex: 'autoAcceptRequests',
    name: 'autoAcceptRequests',
  },
   {
    title:'Description',
    dataIndex: 'description',
    width: 350,
    customRender: ({ text, record }) => {
      return <div>{record.description||'--'}</div>
    },
  },
  {
    title:'Action',
    dataIndex: 'action',
    name: 'action',
    fixed: 'right',
    width: 180,
  },
 ])

const onSearch = () => {
  params.value.page = 1
  init()
}
const returnText = (status) => {
  if(status === 'draft'){
    return 'Edit'
  }else if(status === 'reviewing'){
    return 'Suspend'
  }else if(status === 'approved'){
    return 'Edit'
  }else if(status === 'rejected'){
    return 'Edit'
  }else if(status === 'insufficient_stock'){
    return 'Edit'
  }else if(status === 'offline'){
    return 'Delete'
  }
}
const onStatusChange = () => {
  params.value.page = 1
  init()
} 
const handleRefresh = () => {
  init()
}
const onChangePage = (data) => {
  params.value.page = data.current
  params.value.size = data.pageSize
  init()
}
// const setTime = (time) => {
//   if(!time) return '--'
//   if(Array.isArray(time)){
//     return `${time[0]}.${time[1]}.${time[2]}`
//   }else{
//     return time.replaceAll('-','.')
//   }
// }
// setTimeout(() => {
//   modelRef.value?.open({
//     title: 'Add New Placement',
//     type: 'add'
//   })
// }, 1000)
const init = async() => {
  loading.value = true
  const {data} = await publisherPlacementApi.getPlacement(params.value)
 
  dataList.value = data.data
  tableTotal.value = data.total
  
  loading.value = false
}
const editPlacement = (status,id) => {
  if(status==='offline'){
    Modal.confirm({
    title: 'Notice',
    content: 'Are you sure to delete this placement? This will not effect the accepted campaigns.',
    onOk: async () => {
      const data = await publisherPlacementApi.deletePlacement(id)
      if(data.success){
        message.success('Delete Successfully')
        init()
      }
    }
  })
  }else{
    modelRef.value?.open({
    title: 'Edit Placement',
    type: status,
    id: id
  })
  }
 
}
const offlinePlacement=async(id)=>{
  Modal.confirm({
    title: 'Notice',
    content: 'Are you sure to remove this placement ?This will change status to Removed and Brands can no longer see this.This will not effect the accepted campaigns.',
    onOk: async () => {
      const data = await publisherPlacementApi.offlinePlacement(id)
      if(data.success){
        message.success('Remove Successfully')
        init()
      }
    }
  })
 
}
onMounted(() => {
  init()
})

const addNewPlacement = () => {
  modelRef.value?.open({
    title: 'Add New Placement',
    type: 'add'
  })
}
</script>

<style scoped lang="less">
.action-container{
  display: flex;
  align-items: center;
  gap: 10px;
}
.placement {
  padding: 16px;
  padding-top: unset;
  width: 100%;
  .content-wrapper{
    display: block !important;
  }
  .table-head {
  display: flex;
  height: 64px;
  justify-content: space-between;
  align-items: center;
}
.filters {
    display: flex;
    justify-content: space-between;
    .statusFilter{
      margin-left: 16px;
    }
    
  }
}
</style>